import RichText from "@/components/RichText"
import { createDataAttribute, PortableTextBlock } from "next-sanity"

interface HeadingTextProps {
	heading: string
	text: PortableTextBlock[]
	documentId: string
	_key: string
}

export default function HeadingText({heading, text, documentId, _key}:HeadingTextProps) {
	return (
		<div
			className="section px-site"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}>
			<div className="site-grid">
				<div className="col-span-full md:col-span-6 mb-6 md:mb-0">
					<h2 className='font-500 text-3xl leading-110 -tracking-20'>{heading}</h2>
				</div>
				<div className="col-span-full md:col-span-6">
					<div className="font-400 text-xl leading-115 -tracking-20 space-y-[1em] [&_strong]:font-400">
						<RichText content={text} />
					</div>
				</div>
			</div>
		</div>
	)
}